// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1nafm","sendOtp":"AuthorizeToLogin_sendOtp__2hJRq"};